import React from "react"
// eslint-disable-next-line react/no-deprecated
import { render } from "react-dom"

import { library } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { faIcons as legosFaIcons } from "@ncs/web-legos"
import { faIcons as localFaIcons } from "~/util"

import { setBaseUrl, setEcommBaseUrl } from "@ncs/ncs-api"
import { integrateAnalyticsPlatforms, setUspsUserName, visualSearch } from "@ncs/web-legos"

import App from "~/App"
import { AppProvider } from "~/contexts"
import AnalyticsClient from "~/util/analytics-client"

library.add(...(localFaIcons as any), ...(legosFaIcons as any))

setBaseUrl(import.meta.env.VITE_PORTAL_SERVICE_URL)
setEcommBaseUrl(import.meta.env.VITE_ECOMM_SERVICE_URL)
setUspsUserName(import.meta.env.VITE_USPS_USER_NAME)

const app = (
	<AppProvider>
		<App />
	</AppProvider>
)

render(app, document.getElementById("root"))

visualSearch()
AnalyticsClient.getInstance().init(
	import.meta.env.VITE_AMPLITUDE_KEY,
	import.meta.env.VITE_AMPLITUDE_EXPERIMENT_KEY
)
integrateAnalyticsPlatforms()
